import React from 'react';
import { useApp } from '../context/AppContext';
import {
  Compass,
  Activity,
  Terminal,
  Bot,
  Sliders,
  Video,
  MessageSquareHeart,
  Wifi,
  Home,
  Image
} from 'lucide-react';
import { triggerHaptic } from '../services/purrSynthesizer';

export const BottomTabBar: React.FC = () => {
  const {
    activeLayer,
    activeTab,
    setActiveTab
  } = useApp();

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    triggerHaptic(25);
  };

  const familyTabs = [
    { id: 'cameras', label: 'Cameras', icon: <Video className="w-5 h-5" /> },
    { id: 'fissal', label: 'Fissal AI', icon: <MessageSquareHeart className="w-5 h-5" /> },
    { id: 'devices', label: 'Net & Fix', icon: <Wifi className="w-5 h-5" /> },
    { id: 'living', label: 'Smart Home', icon: <Home className="w-5 h-5" /> },
    { id: 'photos', label: 'Photos', icon: <Image className="w-5 h-5" /> },
  ];

  const devopsTabs = [
    { id: 'cockpit', label: 'Cockpit', icon: <Compass className="w-5 h-5" /> },
    { id: 'diagnostics', label: 'USB & Bench', icon: <Activity className="w-5 h-5" /> },
    { id: 'fissal', label: 'Fissal Core', icon: <Bot className="w-5 h-5" /> },
    { id: 'terminal', label: 'Terminal', icon: <Terminal className="w-5 h-5" /> },
    { id: 'devices', label: 'Aux Decks', icon: <Sliders className="w-5 h-5" /> },
  ];

  const tabs = activeLayer === 'devops' ? devopsTabs : familyTabs;

  const getActiveIndicatorColor = () => {
    if (activeLayer === 'devops') return 'bg-amber-400 shadow-quantum-glow text-amber-300';
    return 'bg-emerald-400 shadow-verdant-glow text-emerald-300';
  };

  return (
    <nav className="shrink-0 bg-[#070a0f]/95 backdrop-blur-xl border-t border-white/10 px-1 pt-2 pb-[calc(env(safe-area-inset-bottom,16px)+8px)] flex justify-around items-center z-40">
      {tabs.map((tab) => {
        const isActive =
          activeTab === tab.id ||
          (tab.id === 'fissal' && activeTab === 'concierge') ||
          (tab.id === 'living' && (activeTab === 'lights' || activeTab === 'note'));
        const colorClasses = getActiveIndicatorColor();
        return (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`flex-1 flex flex-col items-center py-1 px-0.5 rounded-xl transition-all relative ${
              isActive
                ? `${colorClasses} font-semibold`
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            {isActive && (
              <span className={`absolute -top-2 w-6 h-0.5 rounded-full ${colorClasses.split(' ')[0]}`} />
            )}
            <div className={`transition-transform duration-200 ${isActive ? 'scale-110 -translate-y-0.5' : ''}`}>
              {tab.icon}
            </div>
            <span className="text-[10px] mt-0.5 tracking-tight truncate max-w-full">
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
